import { useState, useEffect } from 'react';

const _DEFAULT_WIDTH = 1280; // SSR / non-window fallback
const _safeWidth = () => (typeof window !== 'undefined' && window.innerWidth) || _DEFAULT_WIDTH;

const getLayout = (w) => {
  const isMobile = w < 768;
  const isTablet = w >= 768 && w < 1200;
  const isDesktop = w >= 1200;
  // Desktop-like chrome (sidebar nav, no bottom bar) starts at tablet width
  const showSidebar = !isMobile;
  // Icon-only sidebar on tablet; full labelled sidebar on desktop
  const sidebarWidth = isDesktop ? 232 : showSidebar ? 72 : 0;
  // Cap content column on ultra-wide screens so lines stay readable
  const contentMaxWidth = isDesktop ? 1320 : isTablet ? 960 : null;
  return {
    isMobile,
    isTablet,
    isDesktop,
    showSidebar,
    sidebarWidth,
    contentMaxWidth,
    width: w,
  };
};

export function useLayout() {
  const [layout, setLayout] = useState(() => getLayout(_safeWidth()));
  useEffect(() => {
    if (typeof window === 'undefined') return;
    let timer;
    const onResize = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setLayout(getLayout(_safeWidth())), 100);
    };
    // Sync once on mount in case width changed between SSR and hydration
    setLayout(getLayout(_safeWidth()));
    window.addEventListener('resize', onResize);
    return () => { window.removeEventListener('resize', onResize); clearTimeout(timer); };
  }, []);
  return layout;
}
